<template>
	<div class="page">
		<gc-header header-data="alarmParameter" />
		<div class="page-main" v-loading="loading">
			<div class="page-main-left">
				<gc-sub-title icon="icon-shebei1" text="配置列表" />
				<gc-custom-search
					v-if="orgEnable"
					class="box-select"
					key-word="所属组织"
					type="tree-select"
					width="100%"
					:search-option="orgCodeOptions"
					:props-obj="orgTreeProps"
					:show-search="true"
					:tree-select-clearable="true"
					:search.sync="orgCode"
					:treeSelectClearable="false"
				/>
				<gc-custom-search
					class="box-select"
					key-word="设备类型"
					type="select"
					width="100%"
					filterable
					:search.sync="deviceTypeId"
					:search-option="deviceTypeListOptions"
				/>
				<gc-custom-search
					class="box-select"
					key-word="告警类型"
					type="select"
					width="100%"
					:search-option="alarmTypeOptions"
					:search.sync="alarmType"
				/>
				<ul class="items">
					<li
						class="item"
						v-for="item in alarmItemList"
						:key="item.eventId"
						:class="{ active: form.eventId == item.eventId }"
						:title="item.eventModel ? item.eventModel.name : '--'"
						@click="handleSelectAlarm(item)"
					>
						{{ item.eventModel ? item.eventModel.name : '--' }}
					</li>
					<gc-empty v-show="!alarmItemList.length" />
				</ul>
				<div class="add" v-if="alarmType === '1' && !isCreateStatus">
					<el-button type="primary" size="small" @click="handleCreateSystemAlarm">新增告警</el-button>
				</div>
			</div>
			<div class="page-main-right" v-show="alarmItemList.length">
				<gc-sub-title icon="icon-gaojing1" :text="itemTitle">
					<template #text v-if="alarmType === '1' && !comparisonName">
						<el-select
							style="width: 220px"
							v-model="form.alarmNameId"
							placeholder="请选择告警项名称"
							@change="handleChangeAlarmName"
						>
							<el-option
								v-for="item in systemAlarmNameList"
								:key="item.id"
								:label="item.alarmName"
								:value="item.id"
							></el-option>
						</el-select>
					</template>
					<el-button v-if="canModify" class="btn-save" type="primary" @click="handleSubmitConfig">
						保 存
					</el-button>
					<el-button v-if="isCreateStatus" class="btn-save" type="default" @click="handleCancelConfig">
						取消
					</el-button>
				</gc-sub-title>
				<el-form ref="form" label-position="top" :model="form" :rules="formRules">
					<el-row :gutter="20">
						<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
							<el-form-item label="是否配置该告警项">
								<el-radio-group v-model="form.eventSwitch" :disabled="!canModify">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5">
							<el-form-item label="告警等级" prop="eventLevel">
								<el-select
									v-model="form.eventLevel"
									placeholder="请选择告警等级"
									:disabled="!canModify || !form.eventSwitch"
								>
									<el-option
										v-for="item in alarmLevelOptions"
										:key="item.defaultValue"
										:label="item.name"
										:value="item.defaultValue"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5" v-if="alarmType === '1'">
							<el-form-item label="告警分类" prop="classification">
								<el-select
									v-model="form.classification"
									placeholder="请选择告警等级"
									:disabled="!canModify || !form.eventSwitch || Boolean(comparisonName)"
								>
									<el-option
										v-for="item in alarmClassifyOptions"
										:key="item.defaultValue"
										:label="item.name"
										:value="item.defaultValue"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
							<el-form-item label="人工登记">
								<el-radio-group
									v-model="form.manualHandleSupport"
									:disabled="!canModify || !form.eventSwitch"
								>
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="5">
							<el-form-item label="恢复机制" prop="recoveryMechanism">
								<el-select
									v-model="form.recoveryMechanism"
									placeholder="请选择恢复机制"
									:disabled="!canModify || form.eventSwitch === 0"
								>
									<el-option
										v-for="item in recoveryMechanismOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
							<el-form-item label="是否推送" style="margin-bottom: 0">
								<el-radio-group
									v-model="form.pushSwitch"
									:disabled="!canModify || form.eventSwitch === 0"
								>
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<div v-if="Boolean(comparisonName)">
						<div class="title">配置信息</div>
						<el-form-item class="model-info" prop="comparisonValue" :label="comparisonName">
							<el-input
								type="text"
								v-model="form.comparisonValue"
								placeholder="请填写阈值"
								:disabled="!form.eventSwitch || !canModify"
							/>
							<span class="unit">{{ comparisonUnit }}</span>
						</el-form-item>
					</div>
					<div class="title">联动事件</div>
					<el-form-item>
						<el-checkbox-group v-model="form.pushIds" @change="handlePushIdsChange">
							<div v-for="item in pushTypes" :key="item.defaultValue" class="push-type-item">
								<el-checkbox
									:label="item.defaultValue"
									:name="item.sortCode"
									:disabled="
										form.pushSwitch === 0 ||
										!canModify ||
										pagePushDisabled(item.defaultValue) ||
										!form.eventSwitch
									"
								>
									{{ item.name }}
								</el-checkbox>
								<el-row
									v-if="item.defaultValue === '6' && showDeviceUserSmsPushConfig"
									class="timed-push-config"
									:gutter="20"
								>
									<el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
										<el-form-item label="推送方式" prop="sendMode" style="margin-bottom: 0">
											<el-radio-group
												v-model="form.sendMode"
												:disabled="form.pushSwitch === 0 || !canModify || !form.eventSwitch"
											>
												<el-radio :label="1">实时</el-radio>
												<el-radio :label="2">定时</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
									<el-col v-if="showTimedPushConfig" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
										<el-form-item label="推送时间" prop="pushTime" style="margin-bottom: 0">
											<el-select
												v-model="form.pushTime"
												placeholder="请选择推送时间"
												:disabled="
													form.pushSwitch === 0 ||
													!canModify ||
													!form.eventSwitch ||
													form.sendMode !== 2
												"
											>
												<el-option
													v-for="item in pushTimeOptions"
													:key="item.value"
													:label="item.label"
													:value="item.value"
												></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col v-if="showTimedPushConfig" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
										<el-form-item label="推送周期" prop="pushCycle" style="margin-bottom: 0">
											<el-select
												v-model="form.pushCycle"
												placeholder="请选择推送周期"
												:disabled="
													form.pushSwitch === 0 ||
													!canModify ||
													!form.eventSwitch ||
													form.sendMode !== 2
												"
											>
												<el-option
													v-for="item in pushCycleOptions"
													:key="item.value"
													:label="item.label"
													:value="item.value"
												></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col
										v-if="showTimedPushConfig && form.pushCycle !== 'day'"
										:xs="24"
										:sm="12"
										:md="8"
										:lg="6"
										:xl="4"
									>
										<el-form-item
											:label="pushCycleValueLabel"
											prop="pushCycleValue"
											style="margin-bottom: 0"
										>
											<el-select
												v-model="form.pushCycleValue"
												:placeholder="`请选择${pushCycleValueLabel}`"
												:disabled="
													form.pushSwitch === 0 ||
													!canModify ||
													!form.eventSwitch ||
													form.sendMode !== 2
												"
											>
												<el-option
													v-for="item in pushCycleValueOptions"
													:key="item.value"
													:label="item.label"
													:value="item.value"
												></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col v-if="showTimedPushConfig" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
										<el-form-item label="最大推送次数" prop="maxPushCount" style="margin-bottom: 0">
											<el-input-number
												v-model="form.maxPushCount"
												:min="1"
												:step="1"
												step-strictly
												controls-position="right"
												:disabled="form.pushSwitch === 0 || !canModify || !form.eventSwitch"
											></el-input-number>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</el-checkbox-group>
					</el-form-item>
					<template v-if="alarmType === '1' && !comparisonName">
						<div class="title">告警参数</div>
						<AlarmConfigRule
							ref="alarmConfigRule"
							:disabled="!canModify || !form.eventSwitch"
							:deviceTypeId="deviceTypeId"
							:eventExpression="activeItem.eventExpression"
						/>
					</template>
				</el-form>
			</div>
			<gc-empty class="page-main-right" v-show="!alarmItemList.length" />
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { randomString } from '@/utils'
import { RULE_POSITIVEINTEGERONLY, ruleRequired } from '@/utils/rules'
import {
	apiGetAlarmConfig,
	apiSetAlarmConfig,
	apiSetVeeAlarmConfig,
	apiGetSystemAlarmList,
	apiGetAlarmNameList,
	apiGetConfigPushCreateBIds,
} from '@/apis/alarm.api'
import { apiGetOrganizeList } from '@/apis/organizeRole.api'
import AlarmConfigRule from './components/AlarmConfigRule'

export default {
	name: 'alarmParam',
	components: {
		AlarmConfigRule,
	},
	data() {
		return {
			loading: false,
			deviceTypeId: null,
			alarmType: '2',
			orgCode: null,
			orgCodeOptions: [],
			orgTreeProps: {
				label: 'name',
				id: 'orgCode',
				children: 'children',
			},
			deviceTypeListOptions: [],
			alarmTypeOptions: [
				{ label: '设备告警', value: '2' },
				{ label: '系统告警', value: '1' },
			],
			alarmItemList: [],
			form: {
				alarmNameId: '',
				eventId: '',
				classification: '', // 告警分类
				comparisonValue: '', // 比较值
				eventSwitch: 0, // 告警开关.0:关,1:开
				pushSwitch: 0,
				pushIds: [], // 推送事件id集合
				sendMode: 1,
				pushTime: 5,
				pushCycle: 'day',
				pushCycleValue: '',
				maxPushCount: 1,
				eventModel: {},
				manualHandleSupport: 1,
				eventLevel: '1', // 告警等级
				recoveryMechanism: '', // 恢复机制
			},
			activeItem: {}, //当前活跃的告警项
			systemAlarmNameList: [],
			pushCreateBIds: '',
		}
	},
	created() {
		this.getOrganizationList()
		this.getConfigPushCreateBIds()
		this.queryAlarmNameList()
		this.getDeviceTypeList()
	},

	methods: {
		...mapActions({
			getDeviceTypes: 'common/getDeviceTypeList',
		}),

		async getConfigPushCreateBIds() {
			const data = await apiGetConfigPushCreateBIds()
			this.pushCreateBIds = data
		},

		async queryAlarmNameList() {
			const data = await apiGetAlarmNameList({ tenantId: this.userInfo.tenantId })
			this.systemAlarmNameList = data
		},

		async getOrganizationList() {
			if (!this.orgEnable) return
			try {
				const params = this.visibleSwitchTenant
					? {
							tenantId: this.userInfo.tenantId,
							all: 1,
					  }
					: {}
				const data = await apiGetOrganizeList(params)
				this.orgCodeOptions = data?.children || []
				this.orgCode = this.getDefaultOrgCode(this.orgCodeOptions)
			} catch (error) {
				this.orgCodeOptions = []
				this.orgCode = null
			}
		},

		getDefaultOrgCode(list) {
			if (!list || !list.length) {
				return null
			}

			for (let index = 0; index < list.length; index += 1) {
				const item = list[index]
				if (item && item.orgCode) {
					return item.orgCode
				}
				if (item && item.children && item.children.length) {
					const childOrgCode = this.getDefaultOrgCode(item.children)
					if (childOrgCode) {
						return childOrgCode
					}
				}
			}

			return null
		},

		handleChangeAlarmName(alarmId) {
			const alarmItem = this.systemAlarmNameList.find(m => m.id === alarmId)
			this.activeItem.eventModel.name = alarmItem?.alarmName
		},

		// 声音告警（id=8）和页面推送（id=3）联动，选择声音告警必须选择页面推送
		handlePushIdsChange(e) {
			if (e.includes('8') && !e.includes('3')) {
				this.form.pushIds.push('3')
			}
			this.$nextTick(() => {
				this.$refs.form.clearValidate()
			})
		},

		// 选择声音告警后页面推送默认选中不可编辑
		pagePushDisabled(id) {
			return id == 3 && this.form.pushIds.includes('8') && this.form.pushIds.includes('3')
		},

		getPushFormData(item) {
			const timedPushConfigs = item.timedPushConfigs || []
			const cycleMap = {
				1: 'day',
				2: 'week',
				3: 'month',
			}
			const pushIds = item.pushCreateBIds?.split(',').filter(Boolean) || []
			if (!pushIds.includes('6') && timedPushConfigs.length) {
				pushIds.push('6')
			}
			const hasDeviceUserSmsPush = pushIds.includes('6')
			const timingConfig = hasDeviceUserSmsPush ? timedPushConfigs[0] || {} : {}
			const sendMode = hasDeviceUserSmsPush ? timingConfig.sendMode ?? item.sendMode : item.sendMode
			const pushCycle = cycleMap[timingConfig.timedPushCycleType] || item.pushCycle || 'day'
			let pushCycleValue = ''
			if (pushCycle !== 'day') {
				const cycleValue = timingConfig.timedPushCycleValues ?? item.pushCycleValue
				pushCycleValue =
					cycleValue === undefined || cycleValue === null || cycleValue === '' ? '' : Number(cycleValue)
			}

			return {
				pushSwitch: item.pushSwitch || (pushIds.length ? 1 : 0),
				pushIds,
				sendMode: sendMode || 1,
				pushTime: timingConfig.timedPushHour ?? item.pushTime ?? 5,
				pushCycle,
				pushCycleValue,
				maxPushCount: timingConfig.timedPushMaxCount ?? item.maxPushCount ?? 1,
			}
		},

		getTimedPushConfigs() {
			if (!this.form.eventSwitch || !this.form.pushSwitch || !this.form.pushIds.includes('6')) return []

			const cycleTypeMap = {
				day: 1,
				week: 2,
				month: 3,
			}

			const config = {
				pushId: '6',
				sendMode: this.form.sendMode,
			}

			if (this.form.sendMode === 2) {
				config.timedPushHour = this.form.pushTime
				config.timedPushCycleType = cycleTypeMap[this.form.pushCycle]
				config.timedPushMaxCount = this.form.maxPushCount
				if (this.form.pushCycle !== 'day') {
					config.timedPushCycleValues = String(this.form.pushCycleValue)
				}
			}

			return [config]
		},

		async getDeviceTypeList() {
			const data = (await this.getDeviceTypes()) || []
			this.deviceTypeListOptions = data
			if (data.length) {
				this.deviceTypeId = data[0].deviceTypeId
			}
		},

		/**
		 * 获取设备告警和系统告警参数配置
		 * @param {*} deviceTypeId
		 * @param {*} init
		 */
		async getAlarmConfigList(deviceTypeId, init) {
			this.loading = true
			try {
				const API = this.alarmType === '2' ? apiGetAlarmConfig : apiGetSystemAlarmList
				const data = await API(deviceTypeId, { orgCode: this.orgCode })
				this.alarmItemList =
					this.alarmType === '2'
						? data.list
						: data.map(m => {
								return {
									...m,
									eventId: m.comparisonName ? m.veeId : m.alarmNameId,
									eventSwitch: m.veeSwitch,
									...this.getPushFormData(m),
									eventModel: {
										pushCreateBIds: this.pushCreateBIds,
										name: m.alarmName,
										comparisonName: m.comparisonName,
										comparisonUnit: m.comparisonUnit,
										comparisonValue: m.comparisonValue,
										veeId: m.veeId,
									},
								}
						  })
				if (this.alarmItemList.length) {
					const item = init
						? this.alarmItemList[0]
						: this.alarmItemList.find(i => i.eventId == this.form.eventId) || this.alarmItemList[0]
					this.handleSelectAlarm(item)
				}
			} finally {
				this.loading = false
			}
		},
		handleSelectAlarm(item) {
			this.activeItem = item
			this.form = {
				...this.form,
				...item,
				...this.getPushFormData(item),
				comparisonValue: item.comparisonValue || item?.eventModel?.comparisonDefaultValue || '',
				eventLevel: String(item?.eventLevel || '1'),
				recoveryMechanism: item.recoveryMechanism || 1,
			}
			this.$nextTick(() => {
				this.$refs.form.clearValidate()
			})
		},

		handleCreateSystemAlarm() {
			this.activeItem = {
				status: 'create',
				eventId: randomString(),
				manualHandleSupport: 1,
				eventSwitch: 1,
				pushSwitch: 1,
				pushIds: [],
				sendMode: 1,
				pushTime: 5,
				pushCycle: 'day',
				pushCycleValue: '',
				maxPushCount: 1,
				eventLevel: '1',
				recoveryMechanism: 1,
				eventModel: {
					pushCreateBIds: this.pushCreateBIds,
					name: this.systemAlarmNameList[0]?.alarmName,
				},
			}
			this.form = this.activeItem
			this.form.alarmNameId = this.systemAlarmNameList[0]?.id
			this.alarmItemList.unshift(this.activeItem)
		},

		async handleSubmitConfig() {
			this.$refs.form.validate(async valid => {
				if (valid) {
					this.loading = true
					const params = {
						...this.form,
						deviceTypeId: this.deviceTypeId,
						pushCreateBIds: this.form.pushIds?.join(','),
						timedPushConfigs: this.getTimedPushConfigs(),
						orgCode: this.orgCode,
						veeSwitch: this.form.eventSwitch,
						pushIds: undefined,
						eventModel: undefined,
					}
					try {
						if (this.alarmType === '1' && !this.comparisonName) {
							if (!this.form.alarmNameId) return this.$message.warning('请选择告警名称')
							const data = await this.$refs.alarmConfigRule.validate()
							if (!data && this.form.eventSwitch === 1) return this.$message.warning('请先添加告警规则')
							params.eventExpression = data ? JSON.stringify(data) : null
						}
						const API = this.alarmType === '1' ? apiSetVeeAlarmConfig : apiSetAlarmConfig
						await API(params)
						this.getAlarmConfigList(this.deviceTypeId)
						this.$message.success('保存成功！')
					} finally {
						this.loading = false
					}
				}
			})
		},

		handleCancelConfig() {
			this.alarmItemList.splice(0, 1)
			if (this.alarmItemList?.length) {
				this.handleSelectAlarm(this.alarmItemList[0])
			}
		},
	},

	computed: {
		...mapGetters({
			dataList: 'dataList',
			userInfo: 'userInfo',
		}),
		canModify() {
			return this.$has('monitor:alarm-config:config')
		},
		alarmLevelOptions() {
			return this.dataList.alarmLevel || []
		},
		alarmClassifyOptions() {
			return this.dataList.alarmType || []
		},
		pushTypes() {
			const { pushCreateBIds } = this.form?.eventModel
			const typeIds = pushCreateBIds?.split(',') || []
			const typeMap = this.dataList?.pushType || []
			return typeMap.filter(item => typeIds.includes(item.defaultValue))
		},
		showDeviceUserSmsPushConfig() {
			return this.form.pushIds.includes('6')
		},
		showTimedPushConfig() {
			return this.form.sendMode === 2 && this.showDeviceUserSmsPushConfig
		},
		itemTitle() {
			return this.form?.eventModel?.name || '报警明细'
		},
		comparisonName() {
			return this.form?.eventModel?.comparisonName
		},
		comparisonUnit() {
			return this.form?.eventModel?.comparisonUnit
		},
		pushTimeOptions() {
			return Array.from({ length: 19 }, (_, index) => {
				const value = index + 5
				return {
					label: `${value}点`,
					value,
				}
			})
		},
		pushCycleOptions() {
			return [
				{ label: '天', value: 'day' },
				{ label: '周', value: 'week' },
				{ label: '月', value: 'month' },
			]
		},
		weekOptions() {
			return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'].map((label, index) => ({
				label,
				value: index + 1,
			}))
		},
		monthOptions() {
			return Array.from({ length: 28 }, (_, index) => {
				const value = index + 1
				return {
					label: `${value}号`,
					value,
				}
			})
		},
		pushCycleValueLabel() {
			return this.form.pushCycle === 'week' ? '推送星期' : '推送日期'
		},
		pushCycleValueOptions() {
			if (this.form.pushCycle === 'week') return this.weekOptions
			if (this.form.pushCycle === 'month') return this.monthOptions
			return []
		},
		formRules() {
			if (!this.form.eventSwitch) return {}
			const { comparisonValueReg, comparisonValueRegMsg } = this.form?.eventModel || {}
			const valueRule = [ruleRequired('请填写阈值')]
			const pushRules = this.form.pushSwitch
				? {
						sendMode: [ruleRequired('请选择推送方式')],
						pushTime: this.showTimedPushConfig ? [ruleRequired('请选择推送时间')] : [],
						pushCycle: this.showTimedPushConfig ? [ruleRequired('请选择推送周期')] : [],
						pushCycleValue:
							this.showTimedPushConfig && this.form.pushCycle !== 'day'
								? [ruleRequired(`请选择${this.pushCycleValueLabel}`)]
								: [],
						maxPushCount: this.showTimedPushConfig
							? [ruleRequired('请输入最大推送次数', 'blur'), RULE_POSITIVEINTEGERONLY]
							: [],
				  }
				: {}
			if (comparisonValueReg) {
				valueRule.push({
					pattern: comparisonValueReg,
					message: comparisonValueRegMsg,
				})
			}
			return {
				comparisonValue: valueRule,
				classification: [ruleRequired('请选择告警分类')],
				eventLevel: [ruleRequired('请选择告警等级')],
				recoveryMechanism: [ruleRequired('请选择恢复机制')],
				...pushRules,
			}
		},
		recoveryMechanismOptions() {
			if (this.form.manualHandleSupport === 1) {
				return [
					{ label: '自动恢复', value: 1 },
					{ label: '告警处置', value: 2 },
				]
			}
			return [{ label: '自动恢复', value: 1 }]
		},
		isCreateStatus() {
			return this.alarmItemList.find(m => m.status === 'create')
		},
		orgEnable() {
			return this.userInfo.isOrgEnable || false
		},

		visibleSwitchTenant() {
			return (
				(this.userInfo?.authRoleIds || []).includes('11') || (this.userInfo?.authRoleIds || []).includes('12')
			)
		},
	},

	watch: {
		deviceTypeId(newVal) {
			if (newVal) this.getAlarmConfigList(newVal, true)
		},

		alarmType(newVal) {
			if (this.deviceTypeId && newVal) this.getAlarmConfigList(this.deviceTypeId, true)
		},

		orgCode(newVal) {
			if (this.deviceTypeId && newVal) this.getAlarmConfigList(this.deviceTypeId, true)
		},

		'form.eventSwitch'() {
			this.$nextTick(() => {
				this.$refs.form.clearValidate()
			})
		},
		'form.pushSwitch'() {
			this.$nextTick(() => {
				this.$refs.form.clearValidate()
			})
		},
		'form.sendMode'() {
			this.$nextTick(() => {
				this.$refs.form.clearValidate()
			})
		},
		'form.pushCycle'(newVal) {
			if (newVal === 'day') {
				this.form.pushCycleValue = ''
				return
			}
			if (!this.pushCycleValueOptions.some(item => item.value === this.form.pushCycleValue)) {
				this.form.pushCycleValue = ''
			}
		},

		'form.manualHandleSupport'(newVal) {
			if (newVal === 0) {
				this.form.recoveryMechanism = 1
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.page-main {
	&-left {
		display: flex;
		flex-direction: column;
		padding: 12px 16px 12px 24px;
		border-right: 1px solid #f1f1f1;
		.box-select {
			margin-top: 12px;
		}
		.add {
			margin-top: 8px;
			.el-button--small {
				width: 100%;
			}
		}
		.items {
			margin-top: 12px;
			flex: 1;
			height: 0;
			overflow-y: scroll;
			.item {
				cursor: pointer;
				height: 40px;
				line-height: 40px;
				padding: 0 13px;
				background: #f0f0f0;
				font-weight: 400;
				color: #666666;
				border-radius: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				&.active {
					background: #ebedfa;
					color: #4d6bff;
				}
				+ .item {
					margin-top: 10px;
				}
			}
		}
	}
	&-right {
		::v-deep .el-form {
			padding: 24px;
			padding-bottom: 0;
			.el-form-item {
				margin-bottom: 12px;
			}
			.el-form-item__label {
				color: #ababab;
			}
			.title {
				margin-top: 24px;
				color: #ababab;
				position: relative;
				&::after {
					content: '';
					position: absolute;
					left: 60px;
					right: 0;
					top: 50%;
					border-bottom: 1px solid #f1f1f1;
				}
			}
			.model-info {
				margin-top: 18px;
				.el-form-item__label {
					color: #666;
				}
				.el-input {
					max-width: 260px;
				}
			}
			.unit {
				margin-left: 10px;
				color: #ccc;
			}
			.el-checkbox-group {
				display: block;
				margin-bottom: 12px;
				.push-type-item {
					margin-top: 20px;
				}
				.el-checkbox {
					display: block;
				}
				.timed-push-config {
					margin-top: 12px;
					margin-left: 24px;
					padding-top: 4px;
				}
			}
		}
	}
}
::v-deep {
	.el-button.btn-save {
		min-width: 80px;
	}
}
</style>
